import React from 'react';
import { useAppSelector } from 'redux/hooks';
import { selectActiveOrganization } from 'redux/auth';
import { exists } from 'lib/types';
import LookerStudioReport from '../../LookerStudioReport';

export function PublicNoticesTab() {
  const activeOrganization = useAppSelector(selectActiveOrganization);

  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 relative">
        {exists(activeOrganization) && (
          <div className="absolute inset-0">
            <LookerStudioReport activeOrganization={activeOrganization} />
          </div>
        )}
      </div>
    </div>
  );
}
